// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "fdc7b278e462f89f57e34df6d9374df8" + ".js";
};